import CustomHTML from "components/CustomHTML"
import { Field, useField } from "formik"
import styles from "./styles.module.scss"
import { Question } from "shared/lessons"
import { useContext } from "react"
import { AssignmentTopicContext } from "components/Assignment/AssignmentTopicContext"
import { removeHighlight } from "helpers/htmlElementHighlight"
import { LessonFeedbackContext } from "components/Assignment/contexts/LessonFeedbackContext"
import ToolTip from "components/General/ToolTip"
import { AssignmentContext } from "components/Assignment/AssignmentContext"
import TeacherFeedback from "components/Assignment/components/TeacherFeedback"

type LessonQuestionProps = {
    question: Question,
    sectionNumber: number,
    questionIndex: string,
    questionNumber: number,
    saveLesson: () => void
}

const LessonQuestion = ({question, sectionNumber, questionIndex, questionNumber, saveLesson}: LessonQuestionProps) => {

    const questionId = `question-${sectionNumber}-${questionNumber}` // used for highlighting incomplete question
    const [, , helpers] = useField(questionId)
    const { refreshTopicSectionProgressCheck } = useContext(AssignmentTopicContext)
    const { feedback } = useContext(LessonFeedbackContext)
    const { reworkAssignmentMode } = useContext(AssignmentContext) 

    const questionFeedback = feedback ? feedback.questionFeedbacks?.find(q => q.questionNumber === questionNumber && q.sectionNumber === sectionNumber) : null
    const questionIsGraded = questionFeedback?.grade != null && reworkAssignmentMode

    return(<div id={questionId}>
        <i className="incompleteExclamation d-none fas fa-exclamation-circle text-warning position-absolute" style={{top: '8px', left: '0'}} />
        <span className="pe-2">{questionIndex}. <CustomHTML html={question.content} /></span>
        {questionIsGraded && <ToolTip title="graded"><i className="fas fa-circle-check text-success fs-3 me-1" /></ToolTip>}
        <br />
        {question.imageUpdated && <img
            className={`${styles.lessonImage} img-fluid center-block p-1`} src={question.imagePath}
            alt={question.imageAltText ?? 'Question image'}
        />}
        <Field
            as="textarea"
            className={`${styles.lessonInput} input-glow col-6 ms-auto`}
            name={`question-${sectionNumber}-${questionNumber}`}
            onChange={(e: React.ChangeEvent<any>) => {
                if (e.target.value) {
                    removeHighlight(questionId)
                }
                helpers.setValue(e.target.value)
            }}
            onBlur={() => {
                saveLesson()
                refreshTopicSectionProgressCheck?.()
            }}
        />
        <TeacherFeedback grade={questionFeedback?.grade} comment={questionFeedback?.comment} show={reworkAssignmentMode} />
        <div className={`${styles.printHelper} m-0`} id={`print_helper-${ question.number }`}></div>
        <br/>
    </div>)
}

export default LessonQuestion
